import React, { useState } from 'react';
import { View } from 'react-native';
import InputForm from '../components/InputForm';
import PickerSelect from '../components/PickerSelect';
import { hasRegisteredStates, getStates } from '../utils/country.utils';
import { CommonStyles } from '../styles';
import RowView from './RowView';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import useMonths from '../utils/useTextMonths';
import { EVENTS_ENABLED } from '../config/env';

const suffix = [
  {
    label: 'Mr',
    value: 'Mr',
  },
  {
    label: 'Mrs',
    value: 'Mrs',
  },
  {
    label: 'Ms',
    value: 'Ms',
  },
];

const creditCardType = [
  {
    label: 'Your Company Card (Admin or Personal Use)',
    value: '1',
  },
  {
    label: 'Personal Card (Limited to You)',
    value: '2',
  },
];
const actualYear = new Date().getFullYear();
const years = Array.from({ length: 10 }, (v, k) => ({
  label: (actualYear + k).toString(),
  value: (actualYear + k).toString(),
}));

const PurchaseCreditCardFormik = (props) => {
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('PurchaseCreditCard');
  const { namespace, countryList, creditCardProviders } = props;
  const [stateList, setStateList] = useState([]);
  const [months] = useMonths();

  const fillStates = async (_countryCode, formikProps) => {
    if (hasRegisteredStates(_countryCode)) {
      const res = await getStates(_countryCode);
      formikProps.setFieldValue(namespace + '.ccStateList', res);
      setStateList(res);
    }
  };

  return (
    <View>
      <InputForm
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.cardHolderEmail
        }
        value={props.formikProps.values[namespace]['cardHolderEmail']}
        onChangeText={props.formikProps.handleChange(namespace + '.cardHolderEmail')}
        placeholder={t(tKey('CardholderEmail'))}
      />
      <InputForm
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccName
        }
        value={props.formikProps.values[namespace]['ccName']}
        onChangeText={props.formikProps.handleChange(namespace + '.ccName')}
        placeholder={t(tKey('CardNickname'))}
      />
      <PickerSelect
        onValueChange={(value) => {
          props.formikProps.setFieldValue(namespace + '.ccProvider', value);
        }}
        items={creditCardProviders}
        value={props.formikProps.values[namespace]['ccProvider']}
        placeholder={{ label: t(tKey('CardProvider')) }}
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccProvider
        }
      />
      {!EVENTS_ENABLED ? (
        <PickerSelect
          onValueChange={(value) => {
            props.formikProps.setFieldValue(namespace + '.ccType', value);
          }}
          items={creditCardType}
          value={props.formikProps.values[namespace]['ccType']}
          placeholder={{ label: t(tKey('CardType')) }}
          errorMessage={
            props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccType
          }
        />
      ) : (
        <></>
      )}
      <InputForm
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccNumber
        }
        value={props.formikProps.values[namespace]['ccNumber']}
        onChangeText={props.formikProps.handleChange(namespace + '.ccNumber')}
        placeholder={t(tKey('CardNumber'))}
      />
      <RowView>
        <PickerSelect
          onValueChange={(value) => {
            props.formikProps.setFieldValue(namespace + '.ccMonth', value);
          }}
          items={months}
          value={props.formikProps.values[namespace]['ccMonth']}
          placeholder={{ label: t(tKey('SelectMonth')) }}
          errorMessage={
            props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccMonth
          }
        />
        <PickerSelect
          style={CommonStyles.ml3}
          onValueChange={(value) => {
            props.formikProps.setFieldValue(namespace + '.ccYear', value);
          }}
          items={years}
          value={props.formikProps.values[namespace]['ccYear']}
          placeholder={{ label: t(tKey('SelectYear')) }}
          errorMessage={
            props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccYear
          }
        />
      </RowView>
      {namespace === 'rail' && (
        <InputForm
          value={props.formikProps.values[namespace]['ccCVV']}
          onChangeText={props.formikProps.handleChange(namespace + '.ccCVV')}
          placeholder={t(tKey('EnterCVV'))}
          errorMessage={
            props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccCVV
          }
        />
      )}
      <InputForm
        value={props.formikProps.values[namespace]['ccFirstName']}
        onChangeText={props.formikProps.handleChange(namespace + '.ccFirstName')}
        placeholder={t(tKey('EnterFirstName'))}
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccFirstName
        }
      />
      <InputForm
        value={props.formikProps.values[namespace]['ccBillingAddress']}
        onChangeText={props.formikProps.handleChange(namespace + '.ccBillingAddress')}
        placeholder={t(tKey('EnterBillingAddress'))}
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccBillingAddress
        }
      />
      <InputForm
        value={props.formikProps.values[namespace]['ccCity']}
        onChangeText={props.formikProps.handleChange(namespace + '.ccCity')}
        placeholder={t(tKey('EnterCity'))}
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccCity
        }
      />
      <PickerSelect
        onValueChange={(value) => {
          props.setSelectedCountry(value);
          props.formikProps.setFieldValue(namespace + '.ccState', '');
          props.formikProps.setFieldValue(namespace + '.ccCountry', value);
          fillStates(value, props.formikProps);
        }}
        items={countryList}
        value={props.formikProps.values[namespace]['ccCountry']}
        placeholder={{ label: t(tKey('SelectCountry')) }}
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccCountry
        }
      />
      {hasRegisteredStates(props.formikProps.values[namespace]['ccCountry']) ? (
        <>
          <PickerSelect
            onValueChange={(value) => {
              props.formikProps.setFieldValue(namespace + '.ccState', value);
              props.formikProps.setFieldValue(
                namespace + '.ccZipCode',
                props.formikProps.values[namespace]['ccZipCode']
              );
            }}
            items={stateList}
            value={props.formikProps.values[namespace]['ccState']}
            placeholder={{ label: t(tKey('SelectState')) }}
            errorMessage={
              props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccState
            }
          />
        </>
      ) : (
        <InputForm
          value={props.formikProps.values[namespace]['ccState']}
          onChangeText={props.formikProps.handleChange(namespace + '.ccState')}
          placeholder={t(tKey('EnterState'))}
          errorMessage={
            props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccState
          }
        />
      )}
      <InputForm
        value={props.formikProps.values[namespace]['ccZipCode']}
        onChangeText={props.formikProps.handleChange(namespace + '.ccZipCode')}
        placeholder={t(tKey('EnterZipCode'))}
        errorMessage={
          props.formikProps.submitCount > 0 && props.formikProps.errors[namespace]?.ccZipCode
        }
      />
    </View>
  );
};

export default PurchaseCreditCardFormik;
